<template>
	<div class="tabWrapper wrapUserInformation">
		<div class="noInfo" v-if="hasNoInfo">
			<div class="icon">
				<svg-sprite icon-id="icon-info" width="120" height="120"></svg-sprite>
			</div>
			<div class="text">
				The information is not filled in, please fill in the user information
			</div>
		</div>
		<div v-else class="main">
			<!--			userInfo-->
			<div class="itemInformation userInfo" v-if="hasContacts">
				<div class="head">
					<item-info-row
							icon-id="user"
							:is-item-text="false"
							:is-item-dashed="false"
							value="Contacts"
							is-big-value
							is-flex-start
							custom-class="userName"
					></item-info-row>
				</div>
				<div class="rowWrap"
				     v-for="(item, index) in getListExtension"
				     :key="uniqKey(index)"
				>
					<item-info-row
							icon-id="Phone"
							:text="getExtensionText(item)"
							:value="getExtensionValue(item)"
							isClickValue
							@updateClickValue="onCopyToClipboard(item.value)"
					></item-info-row>
					<div class="btnWrapper">
						<icon-btn
								@updateEvent="onCopyToClipboard(item.value)"
								custom-class="infoBTN"
								:icon-attrs="{iconId: 'icon-copy', width: 20, height: 20, color: '#1dab39',}"
						></icon-btn>
					</div>
				</div>

				<div class="rowWrap"
				     v-for="(item, index) in getListMessengers"
				     :key="uniqKey(index)"
				>
					<item-info-row
							:icon-id="item.icon"
							:text="item.name"
							:value="item.value"
							isClickIcon
							isClickValue
							@updateClickIcon="onOpenMessengers(item)"
							@updateClickValue="onCopyToClipboard(item.value)"
					></item-info-row>
					<div class="btnWrapper">
						<icon-btn
								@updateEvent="onCopyToClipboard(item.value)"
								custom-class="infoBTN"
								:icon-attrs="{iconId: 'icon-copy', width: 20, height: 20, color: '#1dab39',}"
						></icon-btn>
					</div>
				</div>

			</div>

			<!--			inventory-->
			<div class="itemInformation inventory" v-if="inventory && inventory.length > 0">
				<item-info-row
						icon-id="icon-Inventory"
						:is-item-text="false"
						:is-item-dashed="false"
						value="Inventory"
						is-big-value
						is-flex-start
						custom-class="userName"
				></item-info-row>

				<main-table
						padding="0"
						:flag="flag"
						:headers="getHeaders"
						:listItems="inventory"
						@updateClickButton="onClickButton($event, flag)"
						:is-hide-header="false"
						:items-per-page-amount="500"
						:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
						:is-pagination="false"
				></main-table>
			</div>

			<!--			documents-->
			<div class="itemInformation documents" v-if="safeDocumentsList.length > 0">
				<item-info-row
						icon-id="icon-document"
						:is-item-text="false"
						:is-item-dashed="false"
						value="Documents"
						is-big-value
						is-flex-start
						custom-class="userName"
				></item-info-row>

				<main-table
						padding="0"
						:flag="flag"
						:headers="getHeadersDocumentsList"
						:listItems="safeDocumentsList"
						@updateClickButton="onClickButton($event, flag)"
						:is-hide-header="false"
						:items-per-page-amount="500"
						:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
						:is-pagination="false"
				></main-table>
			</div>

			<!--			Payment account information-->
			<div class="itemInformation userInfo" v-if="hasPaymentAccount">
				<div class="head">
					<item-info-row
							icon-id="MoneyReceive"
							:is-item-text="false"
							:is-item-dashed="false"
							value="Payment account information"
							is-big-value
							is-flex-start
							custom-class="userName"
					></item-info-row>
				</div>
				<div class="rowWrap" v-if="pAcc.account_name">
					<item-info-row
							icon-id="folderUser"
							text="Account name"
							:value="pAcc.account_name"
					></item-info-row>
					<div class="btnWrapper">
						<icon-btn
								@updateEvent="onCopyToClipboard(pAcc.account_name)"
								custom-class="infoBTN"
								:icon-attrs="{iconId: 'icon-copy', width: 20, height: 20, color: '#1dab39',}"
						></icon-btn>
					</div>
				</div>
				<div class="rowWrap" v-else>
					<item-info-row
							icon-color="var(--base-orange)"
							icon-id="folderUser"
							text="Account name"
					></item-info-row>
				</div>

				<div class="rowWrap" v-if="pAcc.address">
					<item-info-row
							icon-id="cardUser"
							text="Address"
							:value="pAcc.address"
					></item-info-row>
					<div class="btnWrapper">
						<icon-btn
								@updateEvent="onCopyToClipboard(pAcc.address)"
								custom-class="infoBTN"
								:icon-attrs="{iconId: 'icon-copy', width: 20, height: 20, color: '#1dab39',}"
						></icon-btn>
					</div>
				</div>
				<div class="rowWrap" v-else>
					<item-info-row
							icon-color="var(--base-orange)"
							icon-id="cardUser"
							text="Address"
					></item-info-row>
				</div>

				<div class="rowWrap" v-if="pAcc.iban">
					<item-info-row
							icon-id="money-check-dollar	"
							text="IBAN"
							:value="pAcc.iban"
					></item-info-row>
					<div class="btnWrapper">
						<icon-btn
								@updateEvent="onCopyToClipboard(pAcc.iban)"
								custom-class="infoBTN"
								:icon-attrs="{iconId: 'icon-copy', width: 20, height: 20, color: '#1dab39',}"
						></icon-btn>
					</div>
				</div>
				<div class="rowWrap" v-else>
					<item-info-row
							icon-color="var(--base-orange)"
							icon-id="money-check-dollar	"
							text="IBAN"
					></item-info-row>
				</div>

				<div class="rowWrap" v-if="pAcc.swift">
					<item-info-row
							icon-id="money-check-dollar	"
							text="SWIFT"
							:value="pAcc.swift"
					></item-info-row>
					<div class="btnWrapper">
						<icon-btn
								@updateEvent="onCopyToClipboard(pAcc.swift)"
								custom-class="infoBTN"
								:icon-attrs="{iconId: 'icon-copy', width: 20, height: 20, color: '#1dab39',}"
						></icon-btn>
					</div>
				</div>
				<div class="rowWrap" v-else>
					<item-info-row
							icon-color="var(--base-orange)"
							icon-id="money-check-dollar	"
							text="SWIFT"
					></item-info-row>
				</div>

			</div>

		</div>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>

		<preview-doc
				v-if="linkPreviewDoc"
				@clear-link="clearLinkPreviewDoc"
				:link-doc="linkPreviewDoc"
				:file-name="fileName"
		></preview-doc>
	</div>
</template>

<script>
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";
import IconBtn from "@/pages/Account/IconBtn/iconBtn.vue";
import ItemInfoRow from "@/shared/ItemInfoRow/ItemInfoRow.vue";
import MainTable from "@/shared/MainTable/MainTable.vue";
import { mapActions, mapGetters } from "vuex";
import { accountTableDocuments, accountTableInventory } from "@/pages/Account/constants";
import getUniqId from "@/helper/getUniqId";
import checkStringTelegramUserName from "@/helper/checkStringTelegramUserName";
import PreviewDoc from "@/modules/invoices/preview.vue";
import { getAppUrl } from "@/services";

export default {
	name: "UserTabInformation",

	components: {
		PreviewDoc,
		DialogRemove,
		IconBtn,
		ItemInfoRow,
		MainTable
	},

	computed: {
		...mapGetters([
			'userProfileMyInfo',
		]),
		getHeaders() {
			return accountTableInventory;
		},
		getHeadersDocumentsList() {
			return accountTableDocuments;
		},

		// пусто чи ні вся секція (щоб не повторювати довгі умови у шаблоні)
		hasNoInfo() {
			const c = Array.isArray(this.contacts) ? this.contacts : [];
			const i = Array.isArray(this.inventory) ? this.inventory : [];
			const d = Array.isArray(this.documents) ? this.documents : [];
			return c.length <= 0 && i.length <= 0 && d.length <= 0;
		},
		hasContacts() {
			return Array.isArray(this.contacts) && this.contacts.length > 0;
		},
		getListExtension() {
			return Array.isArray(this.contacts)
				? this.contacts.filter(i => i && i.extension !== null)
				: [];
		},
		getListMessengers() {
			return Array.isArray(this.contacts)
				? this.contacts.filter(i => i && i.extension === null)
				: [];
		},
		hasPaymentAccount() {
			const p = this.payment_account || {};
			const s = v => typeof v === 'string' && v.length > 0;
			return s(p.iban) || s(p.account_name) || s(p.swift) || s(p.address);
		},
		pAcc() {
			const p = this.payment_account || {};
			return {
				iban: p.iban || '',
				account_name: p.account_name || '',
				swift: p.swift || '',
				address: p.address || '',
			};
		},
		safeDocumentsList() {
			return Array.isArray(this.documentsList) ? this.documentsList : [];
		},

	},

	data: () => ({
		inventory: [],
		contacts: [],
		contactsTypes: null,
		payment_account: {},

		activeItem: null,
		activeDelete: null,
		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,

		flag: 'AccountTabSalaryHistory',

		documents: null,
		documentsTypes: null,
		documentsList: null,

		// getListExtension: null,
		// getListMessengers: null,

		linkPreviewDoc: null,
		fileName: null,
	}),

	methods: {
		...mapActions([
			"setAlert",
			"deleteExtensionMyInformation",
			'getUserProfileMyInfo',
		]),
		clearLinkPreviewDoc() {
			this.linkPreviewDoc = null;
		},
		onClickButton({ key, item }) {
			if (key === 'view') {
				const { document_path } = item;
				this.linkPreviewDoc = getAppUrl + document_path;
			}
		},

		uniqKey(id) {
			return getUniqId() + id;
		},

		onCopyToClipboard(text) {
			navigator.clipboard.writeText(text).then(() => {
				this.setAlert({ type: "success", message: `Successfully copied to clipboard [ <b>${ text }</b> ]` });
			}).catch((err) => {
				console.error('Could not copy text: ', err);
				this.setAlert({ type: "error", message: 'Whoops, something went wrong! 🙁' });
			});
		},

		getExtensionValue(item) {
			return `${ item.value }`;
		},

		getExtensionText(item) {
			return `${ item.extension }:`;
		},

		onOpenMessengers(item) {
			const { type, value } = item;
			if (type === 'Telegram') {
				const userName = checkStringTelegramUserName(value);
				const url = 'https://t.me/';
				window.open(`${ url }${ userName }`, '_blank');
			}
			if (type === 'Whatsapp') {
				const url = 'https://wa.me/';
				window.open(`${ url }${ value }`, '_blank');
			}
			if (type === 'Viber') {
				const url = 'viber://chat?number=';
				window.open(`${ url }${ value }`, '_blank');
			}
			if (type === 'Mobile') {
				const url = 'tel:';
				window.open(`${ url }${ value }`, '_blank');
			}
			if (type === 'Email') {
				const url = 'mailto:';
				window.open(`${ url }${ value }`, '_blank');
			}
		},

		async onRemove() {
			if (this.activeDelete === 'extension') {
				const { id } = this.activeItem;
				await this.deleteExtensionMyInformation(id);
			} else if (this.activeDelete === 'messenger') {
				const { id } = this.activeItem;
				await this.deleteMessengerMyInformation(id);
			}
			this.onCloseRemove();
		},

		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},
		onCloseRemove() {
			this.isDialogRemove = false;
		},
	},

	async mounted() {
		const id = this.$route.params.id;

		await this.getUserProfileMyInfo(id);

		const {
			inventory,
			contacts,
			documents,
			documentsTypes,
			payment_account,
		} = this.userProfileMyInfo;

		this.inventory = inventory;
		this.contacts = contacts;
		this.documents = documents;
		this.documentsTypes = documentsTypes;
		this.payment_account = payment_account;

		// this.getListExtension = this.contacts ? this.contacts.filter(item => item.extension !== null) : null;
		// this.getListMessengers = this.contacts ? this.contacts.filter(item => item.extension === null) : null;

		if (Array.isArray(documents) && documents.length > 0) {

			const types = Array.isArray(documentsTypes) ? documentsTypes : [];
			this.documentsList = documents.map(doc => {
				// Ищем соответствующий тип документа
				// const docType = documentsTypes.find(type => type.id === doc.type_id);
				const docType = types.find(type => type && type.id === doc.type_id);

				// Добавляем новое поле type_name
				return {
					...doc, // копируем все свойства объекта doc
					type_name: docType ? docType.name : null // добавляем type_name, если найден тип
				};
			});
		}
	}
};
</script>

<style scoped lang="scss">
@import "UserTabInformation";
</style>

<style lang="scss">
@import "UserTabInformationAll";
</style>

